import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 32px;
`

export const IconWrapper = styled.div`
  margin-left: auto;
  margin-right: 32px;
`